import Vue from 'vue'
import CampingMap from './CampingMap.vue'
import svgJs from './plugins/vueSvgPlugin'

Vue.config.productionTip = false

Vue.use(svgJs)

new Vue({
    el: '#app',
    components: { CampingMap }
  })
